import { render, staticRenderFns } from "./DwGoods.vue?vue&type=template&id=e89ab5c0&scoped=true&"
import script from "./DwGoods.vue?vue&type=script&lang=js&"
export * from "./DwGoods.vue?vue&type=script&lang=js&"
import style0 from "./DwGoods.vue?vue&type=style&index=0&id=e89ab5c0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e89ab5c0",
  null
  
)

export default component.exports